import Glide from '@glidejs/glide';
import copyToClipboard from '../../../helpers/copyToClipboard';
import saveOrRemoveFavourite from '../../../helpers/favourites';
import { IsFavourited } from '../../../helpers/isFavourite';

const latestOpportunitiesComponent: HTMLDivElement = document.querySelector('.latestOpportunities');

if (latestOpportunitiesComponent) {
    const latestOpportunitiesCarousel: Element = latestOpportunitiesComponent.querySelectorAll('.latestOpportunities__carousel-inner')[0];
    const direction: string = document.querySelector('html').getAttribute('dir');
    const latestOpportunitiesCarouselsContainer: Element = latestOpportunitiesComponent.querySelectorAll('.latestOpportunities__carousel')[0];
   
    const glideSettings = {
        type: 'slider',
        perView: 4,
        gap: 24,
        rewind: true,
        bound: true,
        direction: direction || 'ltr',
        breakpoints: {
            1400: {
                perView: 3,
            },
            1100: {
                perView: 2,
                gap: 16,
            },
        },
    };

    let glide = new Glide(latestOpportunitiesCarousel, glideSettings);

    glide.mount();

    if (window.innerWidth <= 767.98) {
        const carouselItems = latestOpportunitiesCarouselsContainer.querySelectorAll('.latestOpportunities__card');
        carouselItems.forEach((item, index) => {
            if (index < 4) {
                item.classList.add('latestOpportunities__card--active');
            } else {
                item.classList.remove('latestOpportunities__card--active');
            }
        });
    }

    const shareButtons: NodeListOf<HTMLButtonElement> = latestOpportunitiesComponent.querySelectorAll('.shareButton');
    if (shareButtons && shareButtons.length > 0) {
        shareButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                copyToClipboard(button);
            });
        });
    }

    const favButtons: NodeListOf<HTMLButtonElement> = latestOpportunitiesComponent.querySelectorAll('.favouriteButton');
    if (favButtons && favButtons.length > 0) {
        favButtons.forEach((button) => {
            const dataIdAttr: string | null = button.getAttribute('data-id');
            const type: string | null = button.getAttribute('data-type');
            const favouritedIds: number[] = JSON.parse(button.getAttribute('data-ids'));

            if (dataIdAttr !== null && favouritedIds != null) {
                const dataId: number = parseInt(dataIdAttr);
                if (IsFavourited(dataId, favouritedIds)) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }

                button.addEventListener('click', (e) => {
                    console.log('small button clicked - events details');
                    saveOrRemoveFavourite(type, dataId, button);
                });
            }
        });
    }
}
